import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    imgDataLoading: false,
    imgData: null,
    error: '',
}

const initImageDataLoading = (state) => {
    return {
        ...state,
        imgDataLoading: true,
    }
}

const imageDataReceived = (state,action) => {
    return {
        ...state,
        imgDataLoading: false,
        imgData: action.imgData,
        error: ''
    }
}

const imageDataErrorReceived = (state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.INIT_BBOX_IMAGE_DATA]: initImageDataLoading,
    [actionTypes.GRAB_BBOX_IMAGE_DATA]: imageDataReceived,
    [actionTypes.GRAB_BBOX_IMAGE_DATA_ERROR]: imageDataErrorReceived
});


// WEBPACK FOOTER //
// ./src/redux/boundingBox/reducer.js